<!-- Sidebar -->
<p-menu [model]="menuItems" class="" styleClass="border-0">
  <ng-template #start>
    <div class="p-2 pl-4 text-3xl font-bold text-color mb-3 hidden lg:block">
        Crowd<span class="text-primary">Sync</span>
    </div>
  </ng-template>
  <ng-template #item let-item>
    <a pRipple class="flex items-center p-menu-item-link pl-0 lg:pl-3" [routerLink]="item.route" routerLinkActive="active">
      <span [class]="item.icon"></span>
      <span class="ml-2">{{ item.key | translate }}</span>
    </a>
  </ng-template>
</p-menu>
<!-- Dev Tools Section -->
<div *ngIf="isAdmin" class="mt-4">
  <div class="pl-4 text-xs text-gray-500 uppercase mb-2">{{ 'generic.menuItems.devtools' | translate }}</div>
  <p-menu [model]="devToolsMenuItems" styleClass="border-0">
    <ng-template #item let-item>
      <a pRipple class="flex items-center p-menu-item-link pl-0 lg:pl-3" (click)="item.action()">
        <span [class]="item.icon"></span>
        <span class="ml-2">{{ item.key | translate }}</span>
        <i class="pi pi-external-link ml-auto text-primary-200"></i>
      </a>
    </ng-template>
  </p-menu>
</div>
<div class="flex items-center p-menu-item-link pr-0 pl-0 cursor-default mt-auto pb-4 border-t" *ngIf="user">
  <a routerLink="/profile" class="pl-1 pr-2 lg:px-2">
    <i class="pi pi-user text-blue-900 w-8 h-8 leading-8! text-start lg:text-center mr-2"></i>
    <span class="text-blue-900">{{ user.first_name }}</span>
  </a>
  <div class="absolute right-0 group">
    <a routerLink="/logout" pButton pRipple [rounded]="true" severity="danger" [text]="true" [raised]="true" size="small" class="flex w-4 h-4 p-4 group-hover:w-24 overflow-hidden transition-all duration-300 bg-white">
      <span pButtonIcon class="translate-x-[1.55rem] group-hover:translate-x-0 duration-300 transition-transform block pi pi-sign-out text-xs"></span>
      <span pButtonLabel class="block opacity-0 group-hover:opacity-100 text-xs transition-opacity duration-300">Logout</span>
    </a>
  </div>
</div>
